export class ExtensionNotice {
    constructor(name, senderId, onOffSwitch, options) {
        this.type = "extension";
        this.senderId = senderId;
        this.onOffSwitch = onOffSwitch;
        this.options = options;
        this.name = name;
    }
    static getType() {
        return "extension";
    }
}
